import React from 'react';

import {Affirm, Icon} from '@optimaxdev/icons';

import classNames from 'classnames';

import {useFeature} from 'components/feature';
import {PaymentStepAgreement} from 'desktop/pages/checkout/components/paymentStepAgreement/paymentStepAgreement';

import {AMAZON_BUTTON_ID_V2} from '../../constants/amazon';
import * as AmazonIcon from '../../img/amazonPay.svg';

import s from './paymentAmazonLogin.scss';

export type PropsType = {
    error: string;
};

/**
 * Payment Amazon Log In for checkout
 *
 * @constructor
 */
export const PaymentAmazonLogin: React.FC<PropsType> = ({error}) => {
    const isFacelift = useFeature('dCheckoutFacelift');
    return (
        <>
            <div className={classNames({[s.textWrapperFacelift]: isFacelift})}>
                <p className={classNames(s.text, {[s.textFaceliftTop]: isFacelift})}>
                    Click the button to be redirected to Amazon.com & complete your purchase.
                </p>
                <PaymentStepAgreement
                    className={classNames(s.text, {[s.textFaceliftBottom]: isFacelift})}
                />
            </div>
            <div className={s.buttonWrap}>
                <button className={s.button} title="Amazon Pay" type="button">
                    <div className={s.amazonButton} id={AMAZON_BUTTON_ID_V2} />
                </button>
                <div className={s.loginText}>
                    login to <Icon className={s.icon} icon={AmazonIcon} />
                </div>
            </div>
            <p className={s.description}>
                Pay over time with <Icon className={s.affirm} icon={Affirm} />
            </p>
            <span className={s.errorAmazon}>{error}</span>
        </>
    );
};
